import React, { useContext, useRef, useState, useEffect } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE --------------------------------
import Card from "../../../../../../Base/Components/Card/Card";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import ModalFull from "../../../../../../Base/Components/Dialog/ModalFull";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";

// ------------------- CONSULTAS A LA API --------------------------------
import { getTasaCambioPorFecha } from "../../../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import {
  getOrdenesDetalles,
  obtenerOrdenCompra,
} from "../../../../../../API/Compras/Ordenes/OrdenesComprasRequests";
import {
  cambiarRevisadoBodega,
  cambiarRecibidoCompras,
  cambiarRecibidofinanzas,
  cambiarEstadoRevisado,
  cambiarEstadoRevisionAdmin,
} from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import { getProveedorCAIporVendor } from "../../../../../../API/Compras/Proveedores/ProveedoresCAIRequest";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import OverlayOC from "./OverlayOC";
import OverlayOCD from "./OverlayOCD";
import OverlayProveedorCAI from "./OverlayProveedorCAI";
import LiquidacionDeIngresos from "./LiquidacionDeIngresos";
import LotesCRUD from "../../../../MateriaPrima/Lotes/LotesCRUD";
import { ValidarFacturaProveedor } from "../../../../Compras/Proveedores/FuncionesProveedores";
import CrudProveedoresCAI from "../../../../Compras/Proveedores/ModalProveedores/CrudProveedoresCAI";
import OrdenesComprasCrud from "../../../../Compras/OrdenesCompras/CrudOrdenesCompras/OrdenesComprasCrud";

const EncabezadoIngresos = ({
  formulario,
  datos,
  estado,
  acciones,
  MateriaPrima,
  Servicios,
  editable,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const [showDialogCAI, setShowDialogCAI] = useState(false);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [orderToShow, setOrderToShow] = useState(null);
  const [, setRequisaDialog] = useState(false);
  const [showDialogLiquidacion, setShowDialogLiquidacion] = useState(false);
  const [showDialogLote, setShowDialogLote] = useState(false);

  const { values, setValues, handleInputChange, resetForm } = formulario;

  const {
    detalles,
    proveedor,
    term,
    monedas,
    tiposIngreso,
    listEstados,
    cuentas,
  } = datos;

  const {
    habilitar,
    setHabilitar,
    showPOColumn,
    setShowPOColumn,
    hab,
    setHab,
    setCheckDollar,
    verCostosBodega,
    setVerCostosBodega,
    isMateriaPrima,
    ingresoSinOC,
    poParaAbrir,
    setPoParaAbrir,
    selected,
    setSelected,
  } = estado;

  const {
    obtenerIngreso,
    getInfo,
    guardarIngresos,
    guardarIngresosBodega,
    agregarNuevaFila,
    eliminarItemDetalle,
    eliminarIngresoCompleto,
    addOC,
    addSingleOC,
    getInfoNew,
    setDetalles,
    setIngresoToShow,
    actualizarIngresosScreenListado,
    setLoading,
  } = acciones;

  const obtenerCAI = async (IdVendor) => {
    if (!IdVendor) {
      return;
    }

    const CAITempo = await getProveedorCAIporVendor(IdVendor);

    if (Array.isArray(CAITempo) && CAITempo.length > 0) {
      return;
    }

    setValues((prevValues) => ({
      ...prevValues,
      NombreSucursal: "",
      IdProveedorCAI: null,
    }));
  };

  const handleTogglePOColumn = () => {
    setShowPOColumn((prevState) => {
      const nuevoModoConPO = !prevState;

      setValues((prevValues) => ({
        ...prevValues,
        IdPurchaseOrder: null,
        PurchaseOrder: "",
        CustomerName: "",
        IdVendor: null,
        IdCountry: null,
        IdTerm: null,
        Term: "",
        NombreSucursal: "",
        IdProveedorCAI: null,
        Factura: "",
        OCE: null,
      }));

      return nuevoModoConPO;
    });
  };

  const handleProveedorChange = (selectedValue) => {
    const proveedorSeleccionado = selectedValue?.value || null;

    setValues((prevValues) => ({
      ...prevValues,

      CustomerName: proveedorSeleccionado,

      IdProveedor: proveedorSeleccionado?.IdVendor || null,

      IdVendor: proveedorSeleccionado?.IdVendor || null,

      IdCountry: proveedorSeleccionado?.IdCountry || null,

      IdProveedorCAI: null,
      NombreSucursal: "",
      Factura: "",
    }));
  };

  const habilitarComponentes = () => {
    setValues((prevValues) => ({
      ...prevValues,
      IdProveedor: prevValues?.IdVendor,
    }));

    setHabilitar(true);
  };

  const limpiarCAI = () => {
    setValues((prevValues) => ({
      ...prevValues,
      IdProveedorCAI: null,
      NombreSucursal: "",
      Factura: "",
    }));
  };

  const CambiarProveedorCAI = (e, op) => {
    const caiSeleccionado = e?.data;

    if (!caiSeleccionado) {
      return;
    }

    setValues((prevValues) => ({
      ...prevValues,
      IdProveedorCAI: caiSeleccionado?.IdProveedorCAI || null,
      NombreSucursal: caiSeleccionado?.NombreSucursal || "",
      Factura: String(prevValues?.Factura || "").trim()
        ? prevValues.Factura
        : caiSeleccionado?.Prefijo || "",
    }));

    if (op?.current) {
      op.current.toggle(e);
    }
  };

  // ASIGNAR AUTOMÁTICAMENTE EL CAI SEGÚN LA FACTURA
  const validarCAIPorFactura = async (numeroFactura) => {
    const factura = String(numeroFactura || "").trim();

    const idVendorActual = values?.CustomerName?.IdVendor || values?.IdVendor;

    const proveedorActual = proveedor.find(
      (item) => Number(item?.IdVendor) === Number(idVendorActual),
    );

    const idCountryActual = Number(
      values?.CustomerName?.IdCountry ||
        values?.IdCountry ||
        proveedorActual?.IdCountry ||
        0,
    );

    // Proveedor extranjero: no utiliza CAI hondureño.
    if (idCountryActual !== 95) {
      return;
    }

    if (!idVendorActual) {
      return;
    }

    if (factura.length !== 19) {
      return;
    }

    const informacionVerificar = {
      CustomerName: values?.CustomerName,
      IdVendor: idVendorActual,
      IdProveedorCAI: null,
      Factura: factura,
      FechaFactura: values?.FechaFactura,
    };

    const resultado = await ValidarFacturaProveedor(informacionVerificar);
    if (resultado?.Valido) {
      const caiEncontrado = resultado?.Valores || {};

      if (caiEncontrado?.IdProveedorCAI) {
        setValues((prevValues) => ({
          ...prevValues,

          IdProveedorCAI: caiEncontrado.IdProveedorCAI,

          NombreSucursal: caiEncontrado.NombreSucursal || "",
        }));
      }

      return;
    }

    setValues((prevValues) => ({
      ...prevValues,
      IdProveedorCAI: null,
      NombreSucursal: "",
    }));

    if (resultado?.Mensaje) {
      toastShow(toast, "warn", "Advertencia", resultado.Mensaje);
    }
  };

  const verificarCampos = () => {
    let err = false;

    if (showPOColumn && !values?.IdPurchaseOrder) {
      toastShow(toast, "error", "Error", "Debe seleccionar una OC.");

      return false;
    }

    if (!values?.IdTipoIngreso && !values?.Inventario?.IdTipoIngreso) {
      err = true;
      toastShow(
        toast,
        "error",
        "Error",
        "Debe seleccionar un Tipo de Ingreso.",
      );
    } else if (!values.CustomerName) {
      err = true;

      toastShow(toast, "error", "Error", "Debe seleccionar un Proveedor.");
    } else if (!values?.Factura) {
      err = true;

      toastShow(toast, "error", "Error", "Debe ingresar una factura.");
    } else if (!values.Comentarios) {
      err = true;

      toastShow(toast, "error", "Error", "Debe ingresar un comentario.");
    } else if (!values?.IdCurrency) {
      err = true;

      toastShow(toast, "error", "Error", "Debe seleccionar una moneda.");
    } else if (!values.TasaCambio) {
      err = true;

      toastShow(toast, "error", "Error", "Debe ingresar una Tasa de Cambio.");
    } else if (!/^\d+(\.\d+)?$/.test(values.TasaCambio)) {
      err = true;

      toastShow(
        toast,
        "error",
        "Error",
        "La Tasa de Cambio solo puede contener números y un solo punto.",
      );
    } else if (!values?.IdTerm && !values?.Term?.IdTerm) {
      err = true;

      toastShow(
        toast,
        "error",
        "Error",
        "Debe seleccionar un Término de Compra.",
      );
    }

    if (values?.Embalaje && !values?.TasaCambioEmbalaje) {
      err = true;

      toastShow(
        toast,
        "error",
        "Error",
        "Tasa Cambio de embalaje es requerida.",
      );
    }

    if (values?.Desaduanaje && !values?.TasaCambioDesaduanaje) {
      err = true;

      toastShow(
        toast,
        "error",
        "Error",
        "Tasa Cambio de desaduanaje es requerida.",
      );
    }

    if (values?.Flete && !values?.TasaCambioFlete) {
      err = true;

      toastShow(toast, "error", "Error", "Tasa Cambio de flete es requerida.");
    }

    if (values?.OtrosCostos && !values?.TasaCambioOtrosCostos) {
      err = true;

      toastShow(
        toast,
        "error",
        "Error",
        "Tasa Cambio de otros costos es requerida.",
      );
    }

    return !err;
  };

  const nuevoIngreso = () => {
    confirmDialog({
      message: "Esta seguro que desea crear un nuevo Ingreso",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",

      accept: () => {
        resetForm();
        setDetalles([]);
        setSelected([]);
        setHab(false);
        setCheckDollar(false);
        setShowPOColumn(true);
        setIngresoToShow(null);
        setHabilitar(true);

        getInfoNew();
      },

      rejectLabel: "No",

      style: {
        backgroundColor: "white",
      },
    });
  };

  const cambiarEstadoRevisionAdminModal = (nuevoEstado) => {
    const idIngresoActual = Number(values?.IdIngreso);

    const idEstadoActual = Number(values?.IdEstadoRevisado);

    const idEstadoNuevo = Number(nuevoEstado);

    if (Number(userAuth?.IdRol) !== 1) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Solo el administrador puede cambiar manualmente el estado.",
      );

      return;
    }

    if (!idIngresoActual || idIngresoActual <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe guardar el ingreso antes de cambiar su estado.",
      );

      return;
    }

    if (idEstadoActual === idEstadoNuevo) {
      return;
    }

    const estadoSeleccionado = listEstados.find(
      (estado) => Number(estado?.IdStatus) === idEstadoNuevo,
    );

    confirmDialog({
      message:
        `¿Está seguro que desea cambiar el estado a ` +
        `"${estadoSeleccionado?.StatusName || ""}"?`,

      header: "Cambiar Estado Revisión",

      icon: "pi pi-exclamation-triangle",

      acceptLabel: "Sí",
      rejectLabel: "No",

      accept: async () => {
        setLoading(true);

        try {
          await cambiarEstadoRevisionAdmin(idIngresoActual, idEstadoNuevo);

          toastShow(
            toast,
            "success",
            "Actualizado",
            "Estado de revisión actualizado correctamente.",
          );

          await obtenerIngreso();

          actualizarIngresosScreenListado();
        } catch (error) {
          toastShow(
            toast,
            "error",
            "Error",
            "No fue posible cambiar el estado de revisión.",
          );
        } finally {
          setLoading(false);
        }
      },

      reject: () => {},

      style: {
        backgroundColor: "white",
      },
    });
  };

  // CAMBIAR ESTADO - REVISIÓN BODEGA
  const cambiarRevisionBodegaModal = async () => {
    if (!values?.IdIngreso || Number(values.IdIngreso) <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe guardar el ingreso antes de cambiar su estado.",
      );

      return;
    }

    if (![1, 38].includes(Number(userAuth?.IdRol))) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "No tiene permisos para realizar la revisión de Bodega.",
      );

      return;
    }

    const estadoActual = Number(values?.IdEstadoRevisado);

    if (![78, 79].includes(estadoActual)) {
      return;
    }

    await cambiarRevisadoBodega(values.IdIngreso);

    await obtenerIngreso();

    actualizarIngresosScreenListado();
  };

  // CAMBIAR ESTADO - RECIBIDO COMPRAS
  const cambiarRecibidoComprasModal = async () => {
    if (!values?.IdIngreso || Number(values.IdIngreso) <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe guardar el ingreso antes de cambiar su estado.",
      );

      return;
    }

    if (![1, 25].includes(Number(userAuth?.IdRol))) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "No tiene permisos para recibir el ingreso en Compras.",
      );

      return;
    }

    const estadoActual = Number(values?.IdEstadoRevisado);

    if (![79, 80].includes(estadoActual)) {
      return;
    }

    await cambiarRecibidoCompras(values.IdIngreso);

    await obtenerIngreso();

    actualizarIngresosScreenListado();
  };

  // CAMBIAR ESTADO - RECIBIDO FINANZAS
  const cambiarRecibidoFinanzasModal = async () => {
    if (!values?.IdIngreso || Number(values.IdIngreso) <= 0) {
      return;
    }

    if (![1, 36].includes(Number(userAuth?.IdRol))) {
      return;
    }

    const estadoActual = Number(values?.IdEstadoRevisado);

    if (![80, 81].includes(estadoActual)) {
      return;
    }

    await cambiarRecibidofinanzas(values.IdIngreso, userAuth.IdUser);

    await obtenerIngreso();

    actualizarIngresosScreenListado();
  };

  // CAMBIAR ESTADO - REVISADO FINANZAS
  const cambiarRevisadoFinanzasModal = async () => {
    if (!values?.IdIngreso || Number(values.IdIngreso) <= 0) {
      return;
    }

    if (![1, 36].includes(Number(userAuth?.IdRol))) {
      return;
    }

    const estadoActual = Number(values?.IdEstadoRevisado);

    if (![81, 82].includes(estadoActual)) {
      return;
    }

    await cambiarEstadoRevisado(values.IdIngreso);

    await obtenerIngreso();

    actualizarIngresosScreenListado();
  };

  const habilitarEncabezado = () => {
    if (!habilitar) {
      return false;
    }

    const detalleBloqueado = detalles.some(
      (detalle) =>
        detalle.Inventario < detalle.Ingreso && detalle?.IdIngresoDetalle > 0,
    );

    return !detalleBloqueado;
  };

  const habilitarEncabezado1 = () => {
    if (!habilitar) {
      return true;
    }

    return detalles.some(
      (detalle) =>
        detalle.Inventario < detalle.Ingreso && detalle?.IdIngresoDetalle > 0,
    );
  };

  const habilitarCAI2 = () => {
    const idVendorActual = values?.CustomerName?.IdVendor || values?.IdVendor;

    const proveedorActual = proveedor.find(
      (item) => Number(item?.IdVendor) === Number(idVendorActual),
    );

    const idCountryActual = Number(
      values?.IdCountry ||
        values?.CustomerName?.IdCountry ||
        proveedorActual?.IdCountry ||
        0,
    );

    return Boolean(habilitar && idVendorActual && idCountryActual === 95);
  };

  const onHideLiquidacion = () => {
    setShowDialogLiquidacion(false);
  };

  const onHideLote = () => {
    setShowDialogLote(false);
    setSelected([]);
  };

  // Función para calcular la fecha de vencimiento basada en la fecha de la factura y el término seleccionado
  const calcularFechaVencimiento = (fechaFactura, terminoSeleccionado) => {
    if (!fechaFactura || !terminoSeleccionado) {
      return null;
    }

    const diasTermino = Number(terminoSeleccionado?.TermValue);

    const fechaBase = new Date(fechaFactura);

    if (Number.isNaN(fechaBase.getTime()) || !Number.isFinite(diasTermino)) {
      return null;
    }

    const fechaVencimiento = new Date(fechaBase);

    fechaVencimiento.setDate(fechaVencimiento.getDate() + diasTermino);

    return fechaVencimiento;
  };

  // Función para cambiar el término de compra y actualizar la fecha de vencimiento
  const cambiarTerminoCompra = (selectedValue) => {
    const terminoSeleccionado =
      selectedValue?.value !== undefined
        ? selectedValue.value
        : selectedValue || null;

    setValues((prevValues) => ({
      ...prevValues,

      Term: terminoSeleccionado,

      IdTerm: terminoSeleccionado?.IdTerm || null,

      FechaVencimiento: calcularFechaVencimiento(
        prevValues?.FechaFactura,
        terminoSeleccionado,
      ),
    }));
  };

  const cambiarMonedaEncabezado = (selectedValue) => {
    const monedaSeleccionada = selectedValue?.value || null;

    setValues((prevValues) => ({
      ...prevValues,

      Moneda: monedaSeleccionada,

      IdCurrency: monedaSeleccionada?.IdCurrency || null,

      Currency: monedaSeleccionada?.Currency || "",
    }));

    setCheckDollar(monedaSeleccionada?.IdCurrency === 1);
  };

  // Función para cambiar la fecha de la factura y obtener la tasa de cambio correspondiente
  const cambiarFechaFactura = async (fechaSeleccionada) => {
    if (!fechaSeleccionada) {
      setValues((prevValues) => ({
        ...prevValues,
        FechaFactura: null,
        FechaVencimiento: null,
      }));

      return;
    }

    const terminoActual =
      typeof values?.Term === "object" && values?.Term
        ? values.Term
        : term.find((item) => Number(item?.IdTerm) === Number(values?.IdTerm));

    const nuevaFechaVencimiento = calcularFechaVencimiento(
      fechaSeleccionada,
      terminoActual,
    );

    const anio = fechaSeleccionada.getFullYear();

    const mes = String(fechaSeleccionada.getMonth() + 1).padStart(2, "0");

    const dia = String(fechaSeleccionada.getDate()).padStart(2, "0");

    const fechaConsulta = `${anio}-${mes}-${dia}`;

    setLoading(true);

    try {
      const respuesta = await getTasaCambioPorFecha(fechaConsulta);

      const tasaNueva = Number(respuesta?.[0]?.TasaCambio);

      const tasaActual = Number(values?.TasaCambio || 0);

      setValues((prevValues) => ({
        ...prevValues,
        FechaFactura: fechaSeleccionada,
        FechaVencimiento: nuevaFechaVencimiento,
      }));

      if (!Number.isFinite(tasaNueva) || tasaNueva <= 0) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          "No se encontró una tasa de cambio para la fecha seleccionada.",
        );

        return;
      }

      if (tasaNueva === tasaActual) {
        return;
      }

      confirmDialog({
        message: `La tasa correspondiente a esta fecha es ${tasaNueva}. ¿Desea aplicarla al ingreso?`,

        header: "Actualizar tasa de cambio",

        icon: "pi pi-exclamation-triangle",

        acceptLabel: "Sí",
        rejectLabel: "No",

        accept: () => {
          setValues((prevValues) => ({
            ...prevValues,

            FechaFactura: fechaSeleccionada,

            FechaVencimiento: nuevaFechaVencimiento,

            TasaCambio: tasaNueva,
          }));
        },

        reject: () => {
          setValues((prevValues) => ({
            ...prevValues,

            FechaFactura: fechaSeleccionada,

            FechaVencimiento: nuevaFechaVencimiento,
          }));
        },

        style: {
          backgroundColor: "white",
        },
      });
    } catch (error) {
      setValues((prevValues) => ({
        ...prevValues,
        FechaFactura: fechaSeleccionada,
        FechaVencimiento: nuevaFechaVencimiento,
      }));

      toastShow(
        toast,
        "error",
        "Error",
        "No fue posible consultar la tasa de cambio.",
      );
    } finally {
      setLoading(false);
    }
  };

  // CARGAR TODA LA INFORMACIÓN DE UNA ORDEN DE COMPRA
  const cargarOrdenCompra = async (ordenSeleccionada) => {
    if (!ordenSeleccionada?.IdPurchaseOrder) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "No se encontró una orden de compra válida.",
      );
      return false;
    }
    /*
      El Overlay actual solamente muestra órdenes
      con IdStatus = 11.
      Aplicamos la misma regla a una PO escrita.
    */
    if (Number(ordenSeleccionada?.IdStatus) !== 11) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "La orden de compra seleccionada no se encuentra disponible para ingreso.",
      );
      return false;
    }
    setLoading(true);
    try {
      // OBTENER DETALLES CON BALANCE DISPONIBLE
      const nuevosDetalles = await getOrdenesDetalles(
        ordenSeleccionada.IdPurchaseOrder,
      );
      if (!Array.isArray(nuevosDetalles) || nuevosDetalles.length === 0) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          "La orden de compra no tiene productos con balance disponible.",
        );
        return false;
      }
      // =====================================
      // CUENTA
      // =====================================
      let cuentaSeleccionada;
      if (Number(ordenSeleccionada?.IdCountry) === 95) {
        cuentaSeleccionada = cuentas.find(
          (cuenta) => Number(cuenta?.IdAccount) === 15,
        );
      } else {
        cuentaSeleccionada = cuentas.find(
          (cuenta) => Number(cuenta?.IdAccount) === 16,
        );
      }
      // =====================================
      // TÉRMINO DE PAGO
      // =====================================
      const idTermPO = ordenSeleccionada?.PaymentTerms || null;
      const terminoPO =
        term.find((item) => Number(item?.IdTerm) === Number(idTermPO)) ||
        term.find(
          (item) =>
            String(item?.Term || "")
              .trim()
              .toLowerCase() ===
            String(ordenSeleccionada?.TerminoPago || "")
              .trim()
              .toLowerCase(),
        ) ||
        null;
      // =====================================
      // MONEDA
      // =====================================
      const idCurrencyPO = nuevosDetalles?.[0]?.IdCurrency || null;
      const monedaPO =
        monedas.find(
          (moneda) => Number(moneda?.IdCurrency) === Number(idCurrencyPO),
        ) || null;
      // =====================================
      // ENCABEZADO
      // =====================================
      setValues((prevValues) => ({
        ...prevValues,
        IdPurchaseOrder: ordenSeleccionada.IdPurchaseOrder,
        PurchaseOrder: ordenSeleccionada.PurchaseOrder,
        CustomerName: ordenSeleccionada.Expr1,
        IdVendor: ordenSeleccionada.IdVendor,
        IdCountry: ordenSeleccionada.IdCountry,
        IdTerm: terminoPO?.IdTerm || idTermPO,
        Term: terminoPO,
        FechaVencimiento: calcularFechaVencimiento(
          prevValues?.FechaFactura,
          terminoPO,
        ),
        Moneda: monedaPO,
        IdCurrency: idCurrencyPO,
        Currency: monedaPO?.Currency || nuevosDetalles?.[0]?.Currency || "",
        IdCuenta: cuentaSeleccionada?.IdAccount || null,
        CuentaConcatenadaCont: cuentaSeleccionada?.CuentaConcatenadaCont || "",
      }));
      setCheckDollar(Number(idCurrencyPO) === 1);
      // =====================================
      // DETALLES
      // =====================================
      addOC(nuevosDetalles);
      return true;
    } catch (error) {
      toastShow(
        toast,
        "error",
        "Error",
        "No fue posible cargar la orden de compra.",
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  const agregraOrdenC = async (e, op) => {
    const ordenSeleccionada = e?.data;
    const cargada = await cargarOrdenCompra(ordenSeleccionada);
    if (cargada && op?.current) {
      op.current.toggle(e);
    }
  };

  // BUSCAR ORDEN DE COMPRA ESCRITA MANUALMENTE
  const buscarOrdenCompraEscrita = async (purchaseOrderIngresada) => {
    const numeroPO = String(
      purchaseOrderIngresada || values?.PurchaseOrder || "",
    ).trim();

    if (!numeroPO) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe ingresar un número de orden de compra.",
      );

      return;
    }

    setLoading(true);

    try {
      const resultado = await obtenerOrdenCompra(numeroPO);

      if (!Array.isArray(resultado) || resultado.length === 0) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          "No se encontró la orden de compra ingresada.",
        );

        return;
      }

      const ordenEncontrada = resultado[0];

      await cargarOrdenCompra(ordenEncontrada);
    } catch (error) {
      toastShow(
        toast,
        "error",
        "Error",
        "No fue posible consultar la orden de compra.",
      );
    } finally {
      setLoading(false);
    }
  };

  const OrdenC = (purchaseOrder) => {
    if (!purchaseOrder) {
      return;
    }

    setOrderToShow(purchaseOrder);
    setOrdenDialog(true);
  };

  useEffect(() => {
    const idVendorActual = values?.CustomerName?.IdVendor || values?.IdVendor;

    if (idVendorActual) {
      obtenerCAI(idVendorActual);
    }
  }, [values?.CustomerName?.IdVendor, values?.IdVendor]);

  useEffect(() => {
    if (!poParaAbrir) {
      return;
    }

    OrdenC(poParaAbrir);

    setPoParaAbrir(null);
  }, [poParaAbrir]);

  const cerrarOrdenCompra = () => {
    if (habilitar && orderToShow) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",

        header: "Cerrar sin guardar",

        icon: "pi pi-exclamation-triangle",

        acceptLabel: "Sí",
        rejectLabel: "No",

        accept: () => {
          setRequisaDialog(null);
          setOrdenDialog(false);
        },

        style: {
          backgroundColor: "white",
        },
      });

      return;
    }

    setRequisaDialog(null);
    setOrdenDialog(false);
    setHabilitar(true);
  };

  const monedaSeleccionadaEncabezado =
    (typeof values?.Moneda === "object" && values?.Moneda
      ? values.Moneda
      : null) ||
    monedas.find(
      (moneda) => Number(moneda?.IdCurrency) === Number(values?.IdCurrency),
    ) ||
    monedas.find(
      (moneda) =>
        String(moneda?.Currency || "")
          .trim()
          .toLowerCase() ===
        String(values?.Currency || detalles?.[0]?.Currency || "")
          .trim()
          .toLowerCase(),
    ) ||
    null;

  const terminoSeleccionadoEncabezado =
    typeof values?.Term === "object" && values?.Term
      ? values.Term
      : term.find((item) => Number(item?.IdTerm) === Number(values?.IdTerm)) ||
        term.find(
          (item) =>
            String(item?.Term || "")
              .trim()
              .toLowerCase() ===
            String(values?.Term || "")
              .trim()
              .toLowerCase(),
        ) ||
        null;

  return (
    <div className="d-flex flex-column justify-content-center">
      <Toast ref={toast} />
      <Card
        contenido={
          <div>
            {/* ================= PRIMERA FILA ================= */}
            <div className="row g-1 align-items-end mt-2">
              {/* No. Ingreso */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <span className="p-inputgroup" style={{ width: "100%" }}>
                  <span
                    className="field p-float-label"
                    style={{ width: "100%" }}
                  >
                    <InputText
                      id="NumeroIngreso"
                      name="NumeroIngreso"
                      value={values?.NumeroIngreso}
                      autoFocus
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                      }}
                      onKeyDown={(e) =>
                        e.keyCode === 13 ? obtenerIngreso() : null
                      }
                    />

                    <label htmlFor="NumeroIngreso">No. Ingreso</label>
                  </span>

                  <Button
                    icon="pi pi-search"
                    type="button"
                    className="p-button-info"
                    onClick={() => obtenerIngreso()}
                    tooltip="Buscar Ingreso"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                  />
                </span>
              </div>

              {/* PO */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <div
                  className="d-flex flex-row"
                  style={{ width: "100%", minWidth: 0 }}
                >
                  <span
                    className="p-float-label"
                    style={{ width: "100%", minWidth: 0 }}
                  >
                    <InputText
                      id="PurchaseOrder"
                      name="PurchaseOrder"
                      value={values?.PurchaseOrder || ""}
                      onChange={(e) =>
                        setValues((prevValues) => ({
                          ...prevValues,
                          PurchaseOrder: e.target.value,
                          IdPurchaseOrder: null,
                        }))
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          buscarOrdenCompraEscrita(e.currentTarget.value);
                        }
                      }}
                      onDoubleClick={() => {
                        if (values?.PurchaseOrder) {
                          OrdenC(values.PurchaseOrder);
                        }
                      }}
                      disabled={!showPOColumn}
                      readOnly={!habilitar || detalles.length > 0}
                      style={{
                        width: "100%",
                        borderEndEndRadius: showPOColumn ? 0 : undefined,
                      }}
                    />

                    <label htmlFor="PurchaseOrder">PO</label>
                  </span>

                  {showPOColumn && (
                    <OverlayOC
                      onChange={agregraOrdenC}
                      detalles={detalles}
                      Servicios={Servicios}
                      MateriaPrima={MateriaPrima}
                    />
                  )}
                </div>
              </div>

              {/* OCE */}
              <div className="col-xl col-lg-2 col-md-3">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <InputText
                    id="OCE"
                    name="OCE"
                    value={values?.OCE || ""}
                    onChange={handleInputChange}
                    disabled={habilitarEncabezado1()}
                    style={{ width: "100%" }}
                  />

                  <label htmlFor="OCE">OCE</label>
                </span>
              </div>

              {/* Proveedor con PO */}
              <div className="col-xl-2 col-lg-4 col-md-6">
                {showPOColumn ? (
                  <span className="p-float-label" style={{ width: "100%" }}>
                    <InputText
                      id="CustomerName"
                      name="CustomerName"
                      disabled
                      value={
                        typeof values?.CustomerName === "object"
                          ? values?.CustomerName?.CustomerName || ""
                          : values?.CustomerName || ""
                      }
                      style={{ width: "100%" }}
                    />

                    <label htmlFor="CustomerName">Proveedor</label>
                  </span>
                ) : (
                  /* Proveedor sin PO */
                  <div style={{ width: "100%", minWidth: 0 }}>
                    <AutoCompleteDropdown
                      enable={habilitarEncabezado()}
                      name={"CustomerName"}
                      value={values?.CustomerName}
                      items={proveedor}
                      field={"CustomerName"}
                      label={"Proveedor"}
                      handleInputChange={handleInputChange}
                      onValueChange={handleProveedorChange}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                    />
                  </div>
                )}
              </div>

              {/* CAI Proveedor */}
              <div className="col-xl-2 col-lg-4 col-md-6">
                <div
                  className="d-flex flex-row align-items-center"
                  style={{ width: "100%", minWidth: 0 }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      minWidth: 0,
                    }}
                  >
                    <span className="p-float-label" style={{ width: "100%" }}>
                      <InputText
                        id="NombreSucursal"
                        value={values?.NombreSucursal || ""}
                        disabled
                        style={{ width: "100%" }}
                      />

                      <label htmlFor="NombreSucursal">CAI</label>
                    </span>

                    {values?.IdProveedorCAI && habilitar && (
                      <button
                        type="button"
                        onClick={limpiarCAI}
                        style={{
                          position: "absolute",
                          right: "0.5rem",
                          top: "50%",
                          transform: "translateY(-50%)",
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          color: "red",
                        }}
                        title="Quitar CAI"
                      >
                        ✖
                      </button>
                    )}
                  </div>

                  <OverlayProveedorCAI
                    IdProveedor={
                      values?.CustomerName?.IdVendor || values?.IdVendor
                    }
                    values={values}
                    onChange={CambiarProveedorCAI}
                    habilitar={habilitarCAI2()}
                  />
                </div>
              </div>

              {/* Factura */}
              <div className="col-xl col-lg-2 col-md-3">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <InputText
                    id="Factura"
                    name="Factura"
                    value={values?.Factura || ""}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                      const facturaActual = String(e.target.value || "").trim();
                      if (facturaActual.length === 19) {
                        validarCAIPorFactura(facturaActual);
                      }
                    }}
                    disabled={habilitarEncabezado1()}
                    style={{ width: "100%" }}
                  />

                  <label htmlFor="Factura">Factura</label>
                </span>
              </div>

              {/* Fecha Factura */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <Calendar
                    id="FechaFactura"
                    name="FechaFactura"
                    value={values?.FechaFactura}
                    dateFormat="dd/mm/yy"
                    disabled={habilitarEncabezado1()}
                    mask="99/99/9999"
                    onChange={(e) => cambiarFechaFactura(e.value)}
                    showIcon
                    icon="pi pi-calendar"
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                    panelStyle={{ zIndex: 99999 }}
                  />

                  <label htmlFor="FechaFactura">Fecha Factura</label>
                </span>
              </div>

              {/* Términos */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <div style={{ width: "100%", minWidth: 0 }}>
                  <AutoCompleteDropdown
                    enable={!habilitarEncabezado1()}
                    name={"Term"}
                    value={terminoSeleccionadoEncabezado}
                    items={term}
                    field={"Term"}
                    label={"Términos"}
                    handleInputChange={handleInputChange}
                    onValueChange={cambiarTerminoCompra}
                  />
                </div>
              </div>

              {/* Fecha Ingreso */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <span className="p-float-label">
                  <Calendar
                    id="FechaIngreso"
                    name="FechaIngreso"
                    value={values?.FechaIngreso}
                    dateFormat="dd/mm/yy"
                    disabled={habilitarEncabezado1()}
                    mask="99/99/9999"
                    onChange={(e) =>
                      setValues({
                        ...values,
                        FechaIngreso: e.value,
                      })
                    }
                    showIcon
                    icon="pi pi-calendar"
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                    panelStyle={{ zIndex: 99999 }}
                  />

                  <label htmlFor="FechaIngreso">Fecha Ingreso</label>
                </span>
              </div>
            </div>
            {/* ================= SEGUNDA FILA ================= */}
            <div className="row g-1 align-items-end mt-2">
              {/* Moneda */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <div style={{ width: "100%", minWidth: 0 }}>
                  <AutoCompleteDropdown
                    name={"Moneda"}
                    value={monedaSeleccionadaEncabezado}
                    items={monedas}
                    field={"Currency"}
                    label={"Moneda"}
                    handleInputChange={handleInputChange}
                    onValueChange={cambiarMonedaEncabezado}
                    enable={!showPOColumn && habilitar && detalles.length === 0}
                  />
                </div>
              </div>

              {/* Tasa Cambio */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <InputNumber
                    id="TasaCambio"
                    name="TasaCambio"
                    value={values?.TasaCambio}
                    minFractionDigits={5}
                    maxFractionDigits={5}
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                    onValueChange={(e) =>
                      setValues({
                        ...values,
                        TasaCambio: e.value,
                      })
                    }
                    disabled={
                      !habilitar ||
                      (userAuth?.IdRol !== 36 && userAuth?.IdRol !== 1)
                    }
                  />

                  <label htmlFor="TasaCambio">Tasa Cambio</label>
                </span>
              </div>

              {/* Monto L */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <InputNumber
                    id="MontoTotalL"
                    value={values?.MontoL ?? 0}
                    onValueChange={(e) =>
                      setValues((prevValues) => ({
                        ...prevValues,
                        MontoL: Number(e.value || 0),
                      }))
                    }
                    disabled={!habilitar}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                  />
                  <label htmlFor="MontoTotalL">Monto L</label>
                </span>
              </div>

              {/* Monto D */}
              <div className="col-xl-1 col-lg-2 col-md-3">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <InputNumber
                    id="MontoTotalD"
                    value={values?.MontoD ?? 0}
                    onValueChange={(e) =>
                      setValues((prevValues) => ({
                        ...prevValues,
                        MontoD: Number(e.value || 0),
                      }))
                    }
                    disabled={!habilitar}
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                  />

                  <label htmlFor="MontoTotalD">Monto D</label>
                </span>
              </div>

              {/* Tipo Ingreso */}
              <div className="col-xl-2 col-lg-3 col-md-4">
                <div style={{ width: "100%", minWidth: 0 }}>
                  <AutoCompleteDropdown
                    name={"Inventario"}
                    value={values?.Inventario}
                    items={tiposIngreso}
                    field={"Inventario"}
                    enable={false}
                    label={"Tipo Ingreso"}
                    handleInputChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Comentario */}
              <div className="col-xl-4 col-lg-6 col-md-8">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <InputText
                    id="Comentarios"
                    name="Comentarios"
                    value={values?.Comentarios || ""}
                    onChange={handleInputChange}
                    disabled={habilitarEncabezado1()}
                    style={{ width: "100%" }}
                  />

                  <label htmlFor="Comentarios">Comentario</label>
                </span>
              </div>

              {/* Fecha Vencimiento */}
              <div className="col-xl-2 col-lg-3 col-md-4">
                <span className="p-float-label" style={{ width: "100%" }}>
                  <Calendar
                    id="FechaVencimiento"
                    name="FechaVencimiento"
                    value={
                      values?.FechaVencimiento
                        ? new Date(values.FechaVencimiento)
                        : null
                    }
                    dateFormat="dd/mm/yy"
                    disabled
                    showIcon
                    icon="pi pi-calendar"
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                  />

                  <label htmlFor="FechaVencimiento">Fecha Vencimiento</label>
                </span>
              </div>
            </div>

            {/* --------------------------BOTONES-----------------------  */}
            <div className="d-flex">
              <div className="d-flex mb-2" style={{ width: "100%" }}>
                <div className="groupEncabezado encabezado__contenido-Card d-flex gap-1 mt-3 align-items-center flex-nowrap w-100">
                  {!showPOColumn && (
                    <Button
                      icon="pi pi-plus"
                      disabled={!habilitar}
                      type="button"
                      className="p-button-info encabezado__herramienta-botones"
                      tooltip="Agregar Items"
                      style={{
                        marginLeft: 1,
                        height: "47px",
                        whiteSpace: "nowrap",
                      }}
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      onClick={(e) => {
                        if (verificarCampos()) {
                          agregarNuevaFila();
                        }
                      }}
                      tabIndex={8}
                    />
                  )}

                  {showPOColumn && values?.IdIngreso > 0 && (
                    <div className="d-flex flex-row">
                      <OverlayOCD
                        onChange={addSingleOC}
                        detalles={detalles}
                        IdPurchaseOrder={values?.IdPurchaseOrder}
                        habilitar={habilitar}
                        Servicios={Servicios}
                      />
                    </div>
                  )}

                  <Button
                    icon="pi pi-save"
                    disabled={!habilitar}
                    className="p-button-primary encabezado__herramienta-botones"
                    tooltip="Guardar"
                    tooltipOptions={{ position: "top" }}
                    style={{ marginLeft: 1, height: "47px" }}
                    onClick={(e) => {
                      if (verificarCampos()) {
                        if (!showPOColumn) {
                          guardarIngresosBodega();
                        } else {
                          guardarIngresos();
                        }
                      }
                    }}
                  />
                  {editable && (
                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      onClick={habilitarComponentes}
                      tooltip="Editar"
                      tooltipOptions={{ position: "top" }}
                      style={{
                        marginLeft: 1,
                        height: "47px",
                      }}
                      disabled={
                        Number(values?.IdIngreso) <= 0 ||
                        Number(values?.IdEstadoRevisado) === 82
                      }
                    />
                  )}
                  <Button
                    icon="pi pi-times"
                    type="button"
                    className="p-button-danger encabezado__herramienta-botones"
                    onClick={() => eliminarItemDetalle()}
                    tooltip="Eliminar detalle"
                    disabled={!habilitar || detalles?.length <= 0}
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{ marginLeft: 1, height: "47px" }}
                  />
                  {editable && (
                    <Button
                      icon="pi pi-trash"
                      type="button"
                      className="p-button-danger encabezado__herramienta-botones"
                      onClick={eliminarIngresoCompleto}
                      tooltip="Eliminar ingreso"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      disabled={
                        Number(values?.IdIngreso) <= 0 ||
                        Number(values?.IdEstado) === 26
                      }
                      style={{
                        marginLeft: 1,
                        height: "47px",
                      }}
                    />
                  )}
                  {editable && (
                    <Button
                      icon="pi pi-book"
                      type="button"
                      className="p-button-info  encabezado__herramienta-botones"
                      onClick={nuevoIngreso}
                      tooltip="Nuevo"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1, height: "47px" }}
                    />
                  )}
                  <Button
                    icon="pi pi-sync"
                    type="button"
                    className="p-button-info encabezado__herramienta-botones"
                    onClick={() => obtenerIngreso()}
                    tooltip="Cargar"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{ marginLeft: 1, height: "47px" }}
                  />
                  <Button
                    icon="ri-folder-user-line"
                    type="button"
                    className="p-button-info encabezado__herramienta-botones"
                    onClick={() => setShowDialogCAI(true)}
                    disabled={
                      !Number(
                        values?.CustomerName?.IdVendor || values?.IdVendor,
                      )
                    }
                    tooltip="CAIs"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                    style={{
                      marginLeft: 1,
                      height: "47px",
                    }}
                  />

                  {(userAuth?.IdRol === 38 || userAuth?.IdRol === 25) && (
                    <Button
                      icon="pi pi-eye"
                      type="button"
                      onClick={() => setVerCostosBodega(!verCostosBodega)}
                      tooltip={
                        verCostosBodega ? "Ocultar Costos" : "Ver Costos"
                      }
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1.5, height: "47px" }}
                    />
                  )}

                  {isMateriaPrima && (
                    <Button
                      icon="ri-stack-line"
                      type="button"
                      className="p-button-secondary  encabezado__herramienta-botones"
                      onClick={() => {
                        setShowDialogLote(true);
                      }}
                      tooltip={"Agregar Lote"}
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                        style: { zIndex: 99999 },
                      }}
                      disabled={habilitarEncabezado1()}
                      style={{ marginLeft: 1, height: "47px" }}
                    />
                  )}

                  {ingresoSinOC && (
                    <Button
                      icon="pi pi-plus"
                      label={showPOColumn ? "Agregar sin PO" : "Agregar con PO"}
                      type="button"
                      className="p-button-secondary  encabezado__herramienta-botones"
                      onClick={handleTogglePOColumn}
                      tooltip={
                        showPOColumn
                          ? "Ocultar Orden Compra"
                          : "Agregar sin Orden Compra"
                      }
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      disabled={hab || detalles?.length > 0}
                      style={{
                        marginLeft: 1,
                        height: "47px",
                        whiteSpace: "nowrap",
                      }}
                    />
                  )}
                  {/* ESTADO REVISIÓN - ADMIN */}
                  <span
                    className="p-float-label"
                    style={{
                      width: "190px",
                      marginLeft: "5px",
                    }}
                  >
                    <Dropdown
                      id="IdEstadoRevisado"
                      value={Number(values?.IdEstadoRevisado) || null}
                      options={listEstados}
                      optionLabel="StatusName"
                      optionValue="IdStatus"
                      filter
                      filterBy="StatusName"
                      onChange={(e) => cambiarEstadoRevisionAdminModal(e.value)}
                      disabled={
                        Number(userAuth?.IdRol) !== 1 ||
                        Number(values?.IdIngreso) <= 0
                      }
                      style={{
                        width: "100%",
                        height: "47px",
                      }}
                    />
                    <label htmlFor="IdEstadoRevisado">Estado Revisión</label>
                  </span>
                  {/* ESTADOS DE REVISIÓN */}
                  <div className="d-flex gap-3 align-items-center mx-2">
                    {[1, 38].includes(Number(userAuth?.IdRol)) && (
                      <span className="d-flex gap-1 align-items-center">
                        <Checkbox
                          checked={[79, 80, 81, 82].includes(
                            Number(values?.IdEstadoRevisado),
                          )}
                          disabled={
                            !values?.IdIngreso ||
                            Number(values?.IdIngreso) <= 0 ||
                            Number(values?.IdEstadoRevisado) >= 80
                          }
                          onChange={() => cambiarRevisionBodegaModal()}
                        />
                        <label>Revisión Bodega</label>
                      </span>
                    )}
                    {[1, 25].includes(Number(userAuth?.IdRol)) && (
                      <span className="d-flex gap-1 align-items-center">
                        <Checkbox
                          checked={[80, 81, 82].includes(
                            Number(values?.IdEstadoRevisado),
                          )}
                          disabled={
                            !values?.IdIngreso ||
                            Number(values?.IdIngreso) <= 0 ||
                            [78, 81, 82].includes(
                              Number(values?.IdEstadoRevisado),
                            )
                          }
                          onChange={() => cambiarRecibidoComprasModal()}
                        />
                        <label>Recibido Compras</label>
                      </span>
                    )}
                    {[1, 36].includes(Number(userAuth?.IdRol)) && (
                      <span className="d-flex gap-1 align-items-center">
                        <Checkbox
                          checked={[81, 82].includes(
                            Number(values?.IdEstadoRevisado),
                          )}
                          disabled={
                            !values?.IdIngreso ||
                            Number(values?.IdIngreso) <= 0 ||
                            [78, 79, 82].includes(
                              Number(values?.IdEstadoRevisado),
                            )
                          }
                          onChange={() => cambiarRecibidoFinanzasModal()}
                        />
                        <label>Recibido Finanzas</label>
                      </span>
                    )}
                    {[1, 36].includes(Number(userAuth?.IdRol)) && (
                      <span className="d-flex gap-1 align-items-center">
                        <Checkbox
                          checked={Number(values?.IdEstadoRevisado) === 82}
                          disabled={
                            !values?.IdIngreso ||
                            Number(values?.IdIngreso) <= 0 ||
                            ![81, 82].includes(Number(values?.IdEstadoRevisado))
                          }
                          onChange={() => cambiarRevisadoFinanzasModal()}
                        />
                        <label>Revisado Finanzas</label>
                      </span>
                    )}
                  </div>
                  {/* COSTOS TOTALES - SOLO ADMIN */}
                  {Number(userAuth?.IdRol) === 1 && (
                    <div className="d-flex gap-1 ms-auto">
                      <span
                        className="p-float-label"
                        style={{ width: "150px" }}
                      >
                        <InputNumber
                          id="CostoTotalL"
                          value={values?.CostoL ?? 0}
                          onValueChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              CostoL: Number(e.value || 0),
                            }))
                          }
                          disabled={!habilitar}
                          minFractionDigits={2}
                          maxFractionDigits={2}
                          style={{ width: "100%" }}
                          inputStyle={{ width: "100%" }}
                        />
                        <label htmlFor="CostoTotalL">Costo L</label>
                      </span>
                      <span
                        className="p-float-label"
                        style={{ width: "150px" }}
                      >
                        <InputNumber
                          id="CostoTotalD"
                          value={values?.CostoD ?? 0}
                          onValueChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              CostoD: Number(e.value || 0),
                            }))
                          }
                          disabled={!habilitar}
                          minFractionDigits={2}
                          maxFractionDigits={2}
                          style={{ width: "100%" }}
                          inputStyle={{ width: "100%" }}
                        />
                        <label htmlFor="CostoTotalD">Costo D</label>
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {showDialogLiquidacion && (
              <Dialog
                visible={showDialogLiquidacion}
                modal
                className="modal__contenedor modal__usuarios"
                onHide={onHideLiquidacion}
                style={{ width: "78%", height: "100%" }}
              >
                <LiquidacionDeIngresos ingreso={values} />
              </Dialog>
            )}

            <Dialog
              visible={showDialogLote}
              modal
              className="modal__contenedor modal__usuarios"
              onHide={onHideLote}
            >
              <LotesCRUD
                showDialog={showDialogLote}
                setShowDialog={setShowDialogLote}
                selected={selected}
                setSelected={setSelected}
                modo={selected.length > 0 ? "Editar" : "Crear"}
                onHide={onHideLote}
              />
            </Dialog>
          </div>
        }
      />

      {/* MODAL DE PROVEEDORES CAI */}
      <Dialog
        visible={showDialogCAI}
        modal
        maximizable
        closeOnEscape={false}
        onHide={() => {
          setShowDialogCAI(false);

          const idVendorActual =
            values?.CustomerName?.IdVendor || values?.IdVendor;

          if (idVendorActual) {
            obtenerCAI(idVendorActual);
          }
        }}
      >
        <CrudProveedoresCAI
          IdProveedor={values?.CustomerName?.IdVendor || values?.IdVendor}
          proveedorSeleccionado={
            typeof values?.CustomerName === "object"
              ? values.CustomerName
              : null
          }
          actualizarProveedoresCAI={() => {
            const idVendorActual =
              values?.CustomerName?.IdVendor || values?.IdVendor;

            if (idVendorActual) {
              obtenerCAI(idVendorActual);
            }
          }}
        />
      </Dialog>

      <ModalFull
        header="Orden de compras"
        visible={ordenDialog}
        onHide={cerrarOrdenCompra}
        contenido={
          <OrdenesComprasCrud
            PurchaseOrder={orderToShow}
            setOrderToShow={setOrderToShow}
            ordenDialog={ordenDialog}
            setOrdenDialog={setOrdenDialog}
            setRequisaDialog={setRequisaDialog}
            infoScreen={getInfo}
            habilitar={habilitar}
            setHabilitar={setHabilitar}
          />
        }
      />
    </div>
  );
};

export default EncabezadoIngresos;
